<template>
  <div>
    ApplicationJobtype summary
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>